import Service from "@/helpers/py-service";
const state = {
  loading: false,
  meta: {},
  list: [],
  vehicleOptions: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_VEHICLE_OPTIONS(state, payload) {
    state.vehicleOptions = payload;
  },

  ADD_LIST(state, payload) {
    state.list.unshift(payload);
  },
  DELETE_LIST(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    return Service.get("core/tenant-vehicle", params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
      })
      .finally(() => (store.state.loading = false));
  },
  vehicleOptions: (store, params) => {
    store.state.loading = true;
    return Service.get(`core/tenant-vehicle-dropdown`, params)
      .then((data) => {
        store.commit("SET_VEHICLE_OPTIONS", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },

  add: (store, params) => {
    return Service.post(`core/tenant-vehicle`, params).then((data) => {
      data?.body.forEach((el) => {
        store.commit("ADD_LIST", el);
      });
      return data.body;
    });
  },
  destroy: (store, params) => {
    return Service.destroy(`core/tenant-vehicle/${params.id}`, params).then(
      () => {
        store.commit("DELETE_LIST", params);
      }
    );
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
  getVehicleOptions(state) {
    return state.vehicleOptions;
  },
  //
};

const vehicleAssign = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default vehicleAssign;
